"use client";
import { useId, useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconArrow from "assets/svg/chevron_right_black.svg";
import SmallIconArrow from "assets/svg/chevron_small_right_black.svg";

import { Listbox } from "@headlessui/react";

import styles from "./styles.module.css";

const Dropdown = ({
  placeHolder,
  options,
  onChange,
  buttonClass,
  listClass,
  disabled,
  smallIcon,
  handleDropdownButton,
  selectedOption,
  errorMessage,
  reset,
  reset2,
}) => {
  const selectedValue =
    selectedOption?.value ||
    selectedOption?.name ||
    selectedOption ||
    placeHolder ||
    options[0]?.value ||
    options[0]?.name;
    
  const [selected, setSelected] = useState(selectedValue);
  const [isVisiblePlaceHolder, setisVisiblePlaceHolder] = useState(true);

  const id = useId();

  const btnClass = classNames({
    [styles.buttonContent]: selected,
    [styles.isVisiblePlaceHolder]: !selected && isVisiblePlaceHolder,
  });

  const dropdownClass = classNames({
    [styles.dropdown]: true,
    [styles.error]: errorMessage,
    [buttonClass]: buttonClass,
  });

  const listClasses = classNames({
    [styles.list]: true,
    [listClass]: listClass,
  });

  const handleChange = (e) => {
    const item = e.value || e.name || e || null;
    setSelected(item);
    onChange && onChange(e);
    setisVisiblePlaceHolder(false);
  };

  useEffect(() => {
    if (placeHolder || selectedValue) {
      setSelected(placeHolder || selectedValue);
    }
  }, [placeHolder, selectedValue]);

  useEffect(() => {
    if (reset || reset2) {
      setSelected(placeHolder || "");
    }
  }, [reset, reset2]);

  return (
    <Listbox value={selected} onChange={handleChange} disabled={disabled}>
      <Listbox.Button className={dropdownClass} onClick={handleDropdownButton}>
        <span className={btnClass}>{selected || placeHolder}</span>
        <span className={styles.icon}>{smallIcon ? <SmallIconArrow /> : <IconArrow />}</span>
      </Listbox.Button>
      {errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
      <Listbox.Options className={listClasses}>
        {options?.map((option, index) => (
          <Listbox.Option
            key={`${id}+${index}`}
            className={() =>
              classNames(styles.option, {
                [styles.wildsand]: option.value === selected,
              })
            }
            value={option}
          >
            <span>{option.value || option.name || option}</span>
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  );
};

Dropdown.propTypes = {
  placeHolder: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  buttonClass: PropTypes.any,
  placeHolderClass: PropTypes.any,
  listClass: PropTypes.any,
  disabled: PropTypes.bool,
  smallIcon: PropTypes.bool,
  handleDropdownButton: PropTypes.func,
  selectedOption: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  errorMessage: PropTypes.string,
  reset: PropTypes.any,
  reset2: PropTypes.any,
};

export default Dropdown;
